// src/features/search/searchSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SearchState, SearchTab, SearchResults } from '@/types/search.types';
import { performSearch } from './searchThunks';

const initialState: SearchState = {
  query: '',
  results: {
    news: [],
    events: [],
    institutional: [],
    sites: [],
    forms: [],
  },
  loading: false,
  error: null,
  activeTab: SearchTab.ALL,
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
    setActiveTab: (state, action: PayloadAction<SearchTab>) => {
      state.activeTab = action.payload;
    },
    clearSearch: (state) => {
      state.query = '';
      state.results = {
        news: [],
        events: [],
        institutional: [],
        sites: [],
        forms: [],
      };
      state.error = null;
      state.activeTab = SearchTab.ALL;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(performSearch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(performSearch.fulfilled, (state, action: PayloadAction<SearchResults>) => {
        state.loading = false;
        state.results = action.payload;
      })
      .addCase(performSearch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Error performing search';
      });
  },
});

export const { setQuery, setActiveTab, clearSearch } = searchSlice.actions;
export default searchSlice.reducer;
